<template>
  <div class="weui-media-box weui-media-box_appmsg">
    <div class="weui-media-box__hd" v-show="img && img.length>0">
      <img class="weui-media-box__thumb" :src="img">
    </div>
    <div class="weui-media-box__bd">
      <h4 class="weui-media-box__title">{{ title }}</h4>
      <p class="weui-media-box__desc">{{ desc }}</p>
    </div>
    <div class="weui-media-box__bd panel-right-area">
      <!--<div class="weui-media-box__desc">-->
        <slot></slot>
      <!--</div>-->
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  export default{
    name: 'c-panel',
    props: {
      img: {
        type: String,
        required: false,
        default: ''
      },
      title: {
        type: String,
        required: true,
        default: ''
      },
      desc: {
        type: String,
        required: false,
        default: ''
      }
    },
    data () {
      return {}
    },
    components: {},
    created () {},
    mounted () {},
    beforeDestroy () {},
    methods: {},
    computed: {},
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?64cda2a2